export enum SaveModalType {
  medmij =  'MedMij',
  default = 'default'
}
